import { render, staticRenderFns } from "./LineChartPHB2BB2C.vue?vue&type=template&id=89d27778&scoped=true&lang=pug&"
import script from "./LineChartPHB2BB2C.vue?vue&type=script&lang=ts&"
export * from "./LineChartPHB2BB2C.vue?vue&type=script&lang=ts&"
import style0 from "./LineChartPHB2BB2C.vue?vue&type=style&index=0&id=89d27778&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d27778",
  null
  
)

export default component.exports